import type { GetSpecialDeckResponse } from "@/services/api/flashcards/get-special-deck"
import SpecialDeckEmptyState from "./special-deck-empty-state"
import GameLayout from "@/modules/flashcards/features/game/game-layout"

interface SpecialDeckLayoutProps {
  data: GetSpecialDeckResponse
}

export default function SpecialDeckLayout({ data }: SpecialDeckLayoutProps) {
  const { description: flashcards } = data

  const gameData = {
    name: "Mazo especial",
    flashcards,
  }

  return (
    <div className="size-full overflow-hidden">
      {flashcards.length > 0 ? <GameLayout gameData={gameData} /> : <SpecialDeckEmptyState />}
    </div>
  )
}
